import { IncomingMessage } from 'http';
import { bugtracker } from '@99designs/design-services-common';
import { designServicesApolloClient, handleQuery } from '@99designs/graph-utils';
import { DesignServicesProductNames } from '../types';
import { ProductsByKeyDocument, ProductsByKeyQuery } from './ProductsByKey.generated';

export type FeaturedProductsType = Record<
    DesignServicesProductNames,
    { title: string; turnaroundTime: number }
>;

export async function getProductsByKey(
    req: IncomingMessage,
    keys: string[],
    locale: string
): Promise<Partial<FeaturedProductsType>> {
    const { error, data } = await handleQuery<ProductsByKeyQuery>(
        designServicesApolloClient(req, locale),
        {
            query: ProductsByKeyDocument,
            variables: { keys: keys },
        }
    );

    if (error) {
        bugtracker.notify(error, (event) => {
            event.context = error.message;
            event.addMetadata('error', error);
            new Error(
                'Design Services landing page - error fetching products from ProductsByKeyQuery'
            );
        });
        return {};
    }

    if (!data || !data.productsByKeys) {
        bugtracker.notify(
            new Error('Design Services landing page - Products not found'),
            (event) => {
                event.context = `Products not found for ${JSON.stringify(req.headers)}`;
            }
        );
        return {};
    }

    return normaliseProducts(data.productsByKeys);
}

export function normaliseProducts(products: ProductsByKeyQuery['productsByKeys']) {
    return products.reduce((acc, cur) => {
        if (cur.__typename === 'ProductFixedPriceProject') {
            const prd = { title: cur.title, turnaroundTime: cur.turnaroundTime };
            const key = cur.name;
            return { [key]: prd, ...acc };
        }

        if (cur.__typename === 'ProductContest') {
            const prd = { title: cur.categoryTitle, turnaroundTime: cur.turnaroundTime };
            const key = cur.category;

            return { [key]: prd, ...acc };
        }
        return acc;
    }, {} as Partial<FeaturedProductsType>);
}
